<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-07 17:43:58
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-28 09:58:12
-->
<template>
  <div id="cockpit">
    <div class="cockpitLeft">
      <leftView
        @getEntList="getEntList"
        @getEnt="getEnt"
        @getLabelList="getLabelList"
        @leftRemoveTag="leftRemoveTag"
        :selectLabelIdList="selectLabelIdList"
        :reverseSelectionItem="reverseSelectionItem"
      ></leftView>
    </div>
    <mapCenter :entList="entList" @mapGetEnt="mapGetEnt" />
    <div class="cockpitCenter">
      <centerView
        @getSelectLabel="getSelectLabel"
        :leftRemoveLabel="leftRemoveLabel"
        :leftLabelList="labelList"
      ></centerView>
    </div>
    <div class="cockpitRight">
      <rightView
        :labelList="labelList"
        :creditCode="creditCode"
        :entName="entName"
        @openEnt="openEnt"
        :selectLabelIdList="selectLabelIdList"
        :reverseSelectionItem="reverseSelectionItem"
      ></rightView>
    </div>
    <dialogView :entName="entName" :creditCode="creditCode" ref="dialog" />

    <div class="caprock">
      <div class="bg_img"></div>
    </div>
  </div>
</template>

<script>
// import rightComponent from './components/right/index.vue'
import leftView from './components/left.vue'
import rightView from './components/right.vue'
import mapCenter from './components/mapCenter'
import dialogView from './components/dialogView'
import centerView from './components/center'

export default {
  name: 'BigScreen',
  computed: {},
  components: {
    mapCenter,
    leftView,
    rightView,
    dialogView,
    centerView
    // CockpitLeft,
    // rightComponent
  },
  watch: {},
  data() {
    return {
      isShowDialog: false,
      entList: null,
      label: { name: '', remark: '' },
      labelList: [],
      entName: null,
      creditCode: null,
      selectLabelIdList: [], // 中间选中的标签
      reverseSelectionItem: [],
      leftRemoveLabel: null // 左侧移除的标签
    }
  },
  mounted() {},
  methods: {
    getEntList(val) {
      // console.log(val)
      this.entList = [...val]
    },
    // getLabel(val) {
    //   console.log(val)
    //   this.label = { ...val }
    // },
    getLabelList(val) {
      // console.log(val)
      this.labelList = val
    },
    mapGetEnt(val) {
      this.entName = val.entName
      this.creditCode = val.creditCode
      // this.$refs.dialog.changeShow()
    },
    getEnt(val) {
      this.entName = val.entName
      this.creditCode = val.creditCode
      // this.$refs.dialog.changeShow()
    },
    openEnt() {
      this.$refs.dialog.changeShow()
    },
    getSelectLabel(val) {
      this.selectLabelIdList = val.selectLabelIdList
      this.reverseSelectionItem = val.reverseSelectionItem
    },
    leftRemoveTag(val) {
      this.leftRemoveLabel = val
    }
  }
}
</script>

<style lang="scss" scoped>
#cockpit {
  width: 100%;
  height: 100%;
  background: url('~@/assets/images/newMap.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.cockpitRight {
  position: absolute;
  right: 0.4rem;
  z-index: 500;
  box-sizing: border-box;
  height: 100%;
}
.cockpitLeft {
  position: absolute;
  left: 0.4rem;
  z-index: 500;
  box-sizing: border-box;
  height: 100%;
}
.cockpitCenter {
  position: absolute;
  top: 6%;
  left: 27%;
  z-index: 999;
}
.caprock {
  width: 100%;
  height: 100%;
  position: absolute;
  .bg_img {
    background: url('~@/assets/images/light-bg.png') no-repeat;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
  }
}
</style>
